import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'ebs-loading-dialog',
  templateUrl: './loading-dialog.component.html',
  styleUrls: ['./loading-dialog.component.scss'],
})
export class LoadingDialogComponent implements OnInit {
  visible: boolean = false;

  constructor(private ref: DynamicDialogRef) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.visible = true;
    }, 5000);
  }

  close() {
    this.ref.close();
  }
}
